/**
 * 新自选股 首页
 */

import React from "react"
import "./index.less"
import { Header } from "./components/header"
import { Indices } from "./components/indices"
import { FavorList } from "./components/favor_list"
import { FavorTab } from "./components/favor_tab"
import { AdvertiseTopZXG } from "../../shared/advertise_top_zxg"

export function ZXG() {
  return (
    <>
      <AdvertiseTopZXG />
      <div className="hq-zxg">
        <Header />
        <FavorTab />
        <Indices />
        <FavorList />
      </div>
    </>
  )
}
